// extracted by mini-css-extract-plugin
export default {"messageInfo":"Message_messageInfo__qm+mu","unregistered":"Message_unregistered__2acco","active":"Message_active__CNcbJ","disableUserSelect":"Message_disableUserSelect__jYG-l"};